import { createContext } from 'react';

interface AccordionContext {
    expanded(id: string): boolean;
    toggleExpanded(id: string): void;
}

export default createContext<AccordionContext>({} as AccordionContext);
